import { listEnumNumbers } from "@protobuf-ts/runtime"
import { Account_Type } from "gen/coa/models_pb"
import {
  useLocalSearchPopoverSelect,
  UseLocalSearchPopoverSelectProps,
} from "shared-web/components/composite/popover"

import { Accounting } from "lib/accounting"

type UseAccountTypesPopoverSelectProps = Pick<
  UseLocalSearchPopoverSelectProps<Account_Type>,
  "selected" | "onSelect" | "defaultSelected"
>

function useAccountTypesPopoverSelect(
  props: UseAccountTypesPopoverSelectProps
) {
  return useLocalSearchPopoverSelect<Account_Type>({
    items,
    keyExtractor,
    labelExtractor,
    ...props,
  })
}

const items = listEnumNumbers(Account_Type)
  .filter(Boolean)
  .sort((a, b) => labelExtractor(a).localeCompare(labelExtractor(b)))

function keyExtractor(t: Account_Type) {
  return t.toString()
}

function labelExtractor(t: Account_Type) {
  return Accounting.accountTypeName(t)
}

export default useAccountTypesPopoverSelect
